
export const GEOSERVER_URL = ''
export const WMS_URL = GEOSERVER_URL + '/wms/'


export const SERVER_URL = 'https://api-dinhtotdong.ditich.metatwin.vn'
export const SERVER_NAME = "Du Lịch Định Hoá"